import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';

const MYTRIPS_LOGIN_PAGE = '/mytripslogin/';
const MYTRIPS_LOGIN_CATEGORY = 'opensa';

const MyTripsLoginTrackingProvider = createTrackingPageProvider({
  category: MYTRIPS_LOGIN_CATEGORY,
  pageMapper: () => MYTRIPS_LOGIN_PAGE,
  pageViewName: '', // Keep this prop empty with MFEs.
});

export default MyTripsLoginTrackingProvider;
